import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SlidersHorizontal } from 'lucide-react';
import { products } from '../data/mockData';
import { useAppContext } from '../context/AppContext';
import { useDragScroll } from '../hooks/useDragScroll';
const CATEGORIES = ['All', 'Jerseys', 'Cleats', 'Gear'];
export function Catalog() {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    selectedCountry
  } = useAppContext();
  const filters = useDragScroll<HTMLDivElement>();
  const initialCategory = searchParams.get('category') || 'All';
  const [activeCategory, setActiveCategory] = useState(initialCategory);
  const filteredProducts = useMemo(() => {
    return products.filter(p => {
      if (activeCategory !== 'All' && p.category !== activeCategory) return false;
      // If we wanted to strictly filter by country, we could, but let's show all for now
      // or prioritize selected country. For this demo, we'll just show all that match category.
      return true;
    });
  }, [activeCategory]);
  return <div className="flex flex-col w-full min-h-full bg-zinc-950" data-id="element-53">
      {/* Header / Title */}
      <div className="px-4 py-6 border-b border-zinc-900" data-id="element-54">
        <h1 className="font-display text-4xl mb-2" data-id="element-55">SHOP</h1>
        <p className="text-sm text-zinc-400" data-id="element-56">
          Showing gear for{' '}
          <span className="text-white font-bold" data-id="element-57">{selectedCountry.name}</span>{' '}
          and more.
        </p>
      </div>

      {/* Filters & Categories */}
      <div className="sticky top-0 z-40 bg-zinc-950/90 backdrop-blur-md border-b border-zinc-900" data-id="element-58">
        <div ref={filters.ref} {...filters.dragProps} className="flex items-center px-4 py-3 gap-4 overflow-x-auto no-scrollbar select-none" data-id="element-59">
          <button className="shrink-0 flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-zinc-400 border-r border-zinc-800 pr-4" data-id="element-60">
            <SlidersHorizontal className="w-4 h-4" data-id="element-61" />
            Filter
          </button>

          <div className="flex gap-6" data-id="element-62">
            {CATEGORIES.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`shrink-0 text-[13px] font-bold uppercase tracking-wider pb-1 border-b-2 transition-colors ${activeCategory === cat ? 'border-white text-white' : 'border-transparent text-zinc-500 hover:text-zinc-300'}`} data-id="element-63">
                {cat}
              </button>)}
          </div>
        </div>
      </div>

      {/* Product Grid */}
      <div className="p-4 grid grid-cols-2 gap-x-4 gap-y-10" data-id="element-64">
        {filteredProducts.map(product => <Link key={product.id} to={`/product/${product.id}`} className="flex flex-col group" data-id="element-65">
            <div className="relative aspect-[3/4] bg-zinc-900 mb-3 overflow-hidden" data-id="element-66">
              <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-67" />
              {product.badges.length > 0 && <div className="absolute top-2 left-2 flex flex-col gap-1" data-id="element-68">
                  {product.badges.map(badge => <span key={badge} className="bg-white text-black text-[10px] font-bold uppercase px-2 py-1" data-id="element-69">
                      {badge}
                    </span>)}
                </div>}
            </div>
            <div className="flex flex-col gap-1" data-id="element-70">
              <div className="flex justify-between items-start gap-2" data-id="element-71">
                <h3 className="font-bold text-sm leading-tight uppercase" data-id="element-72">
                  {product.name}
                </h3>
                <span className="font-display text-sm" data-id="element-73">${product.price}</span>
              </div>
              <p className="text-xs text-zinc-400" data-id="element-74">{product.subtitle}</p>
            </div>
          </Link>)}
      </div>

      {filteredProducts.length === 0 && <div className="flex-1 flex items-center justify-center p-8 text-center text-zinc-500" data-id="element-75">
          No products found for this category.
        </div>}
    </div>;
}